import React, { useEffect, useRef, useState } from 'react';
import Head from 'next/head';
import cn from 'classnames';
import { platform } from 'utils/index';
import { action, actionServer } from 'action/index';
import Layout from 'components/layout';
import { downloadCount } from 'utils/statics';
import style from './index.module.scss';
import { isShowWebRtc } from '../../utils/try';
import { Button, Form, Input } from 'antd';
import { IClientItem, qrCode, clientList, formList, IFormItem } from 'constants/try/index';
import TryModal from 'components/tryModal';

const FormItem = Form.Item;

const Try = () => {
  const [submitStatus, setSubmitStatus] = useState(false);
  const [appList, setAppList] = useState<IClientItem[]>([]);
  const [form] = Form.useForm();
  const [appType, setAppType] = useState('ios');
  const modalRef = useRef<any>(null);

  const getPlatformUrl = async () => {
    const versionList = [...clientList].map((item: IClientItem) => {
      if (item.platform) {
        return actionServer.getClientInfo(item.platform);
      }
      return item;
    });
    await Promise.all(versionList).then((list: any[]) => {
      list.forEach((item: any, index: number) => {
        const { appUrl, platform } = item;
        const originPlatform = clientList[index].platform;
        const platKey = clientList[index].key;
        if (originPlatform && platform === originPlatform) {
          clientList[index].downloadUrl = appUrl;
        }
        if (platKey === 'webRTC') {
          clientList[index].show = isShowWebRtc();
        }
      });
    });
    setAppList(clientList);
  };

  useEffect(() => {
    getPlatformUrl();
    const isIos = platform().ios;
    setAppType(isIos ? 'ios' : 'android');
  }, []);

  const onFinish = async (values: any) => {
    setSubmitStatus(true);
    if (!values) return;
    values.applicationType = '1';

    const result = await action.submit(values, 'try');

    if (!result) {
      modalRef.current?.open?.(false, true);
    } else {
      modalRef.current?.open?.(true, true);
    }
    form.resetFields();
    setSubmitStatus(false);
  };

  // 埋点
  const trackEvent = (params: { category: string; action?: string }, type?: string) => {
    downloadCount({}, { ...params });
    if (type) {
      actionServer.statisticsSearch(type);
    }
  };

  return (
    <Layout layoutClass={style.layout}>
      <Head>
        <title>立即试用</title>
      </Head>
      <div className={style.banner}>
        <div className={style.title}>立即试用</div>
        <div className={style.desc}>体验人人都会用的云视频会议</div>
      </div>
      <div className={style.phone}>
        <div className={style.container}>
          <div className={style.left}>
            <div className={style.title}>手机App</div>
            <div className={cn(style.desc, 'for-pc')}>2秒组会，1秒入会，随时随地参加云视频会议</div>
            <div className={cn(style.desc, 'for-mobile')}>
              2秒组会，1秒入会
              <br />
              随时随地参加云视频会议
            </div>
            <div className={cn(style.qrCode, 'for-pc')}>
              <img src={qrCode} alt="" />
              <div className={style.platform}>扫码试用（iOS，Android）</div>
            </div>
            <div className={cn(style.app, 'for-mobile')}>
              <Button type="primary" href="https://a.app.qq.com/o/simple.jsp?pkgname=com.ainemo.dragoon">
                试用{appType === 'ios' ? 'iOS' : 'Android'}客户端
              </Button>
              <div className={style['other-app']}>同时支持{appType !== 'ios' ? 'iOS' : 'Android'}版本</div>
            </div>
          </div>
          <div className={style.right}>
            <img className={'for-pc'} src="https://devcdn.xylink.com/xylink_website_doc/images/try/app%E5%88%87%E5%9B%BE.png" alt="" />
            <img
              className={'for-mobile'}
              src="https://devcdn.xylink.com/xylink_website_doc/images/try/mobile/%E6%96%B0%E7%9A%84%E7%AB%8B%E5%8D%B3%E8%AF%95%E7%94%A8%E7%A7%BB%E5%8A%A8%E7%89%88-app%E9%85%8D%E5%9B%BE.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div className={style.client}>
        <div className={style.container}>
          <div className={style.left}>
            <img
              src="https://devcdn.xylink.com/xylink_website_doc/images/try/%E6%96%B0%E7%9A%84%E7%AB%8B%E5%8D%B3%E8%AF%95%E7%94%A8%E7%A7%BB%E5%8A%A8%E7%89%88-%E7%94%B5%E8%84%91%E7%AB%AF%E9%85%8D%E5%9B%BE.png"
              alt=""
            />
            <div className={cn(style.tryDesc, 'for-mobile')}>Windows和Mac电脑客户端请访问电脑版试用</div>
          </div>
          <div className={style.right}>
            <div className={style.title}>电脑客户端</div>
            <div className={cn(style.desc, 'for-pc')}>贴近办公场景，更高品质的音视频体验，更丰富的会议管理功能</div>
            <div className={cn(style.desc, 'for-mobile')}>
              贴近办公场景
              <br />
              更高品质的音视频体验
              <br />
              更丰富的会议管理功能
            </div>
            <div className={cn('for-pc')}>
              {appList.map((item: IClientItem) => {
                return item.show ? (
                  <Button key={item.name} onClick={() => trackEvent(item.track, item.type)} className={style.clientItem} type="primary" size="large" href={item.downloadUrl}>
                    {item.name}
                  </Button>
                ) : null;
              })}
            </div>
          </div>
        </div>
      </div>
      <div className={style.form}>
        <div className={style.container}>
          <div className={style.left}>
            <div className={style.title}>硬件终端</div>
            <div className={cn(style.desc, 'for-pc')}>专业的智能硬件终端，感受在会议室里视频沟通的沉浸体验</div>
            <div className={cn(style.desc, 'for-mobile')}>
              专业的智能硬件终端
              <br />
              感受在会议室里视频沟通的沉浸体验
            </div>
          </div>
          <img
            className={cn(style.deviceImage, 'for-mobile')}
            src="https://devcdn.xylink.com/xylink_website_doc/images/try/mobile/%E6%96%B0%E7%9A%84%E7%AB%8B%E5%8D%B3%E8%AF%95%E7%94%A8%E7%A7%BB%E5%8A%A8%E7%89%88-%E7%A1%AC%E4%BB%B6%E9%85%8D%E5%9B%BE.png"
            alt=""
          />
          <Form form={form} className={style.formInfo} onFinish={onFinish}>
            <div className={style.title}>申请试用硬件终端</div>
            {formList.map((item: IFormItem) => {
              return (
                <FormItem key={item.name} name={item.name} rules={item.rules}>
                  {item.isTextArea ? (
                    <Input.TextArea placeholder={item.placeholder} maxLength={item.maxLength} className={style[item.className as string]} />
                  ) : (
                    <Input placeholder={item.placeholder} />
                  )}
                </FormItem>
              );
            })}
            <FormItem>
              <Button type="primary" htmlType="submit" loading={submitStatus}>
                {submitStatus ? '提交中...' : '提交'}
              </Button>
            </FormItem>
          </Form>
        </div>
      </div>
      <TryModal ref={modalRef} />
    </Layout>
  );
};

export default Try;
